import { API } from "../../Common/lib/api";
import { getUserSession } from "../../Common/lib/Session";

export default async function doiRequest(projectId, title, doi) {
  const session = await getUserSession();

  await API.doiRequests.create({
    projectID: String(projectId),
    projectTitle: title,
    userID: session.username,
    doiRequested: doi,
  });

  const result = await API.projects.update({
    id: projectId,
    DOI: "Requested",
  });
  return result.data.updateProject;
}
